module.exports = __webpack_public_path__ + "img/a1.12a00afc.svg";